import {Typography} from '@yandex-delivery/blocks'
import React from 'react'

import {usePaymentTitle} from './hooks'
import type {Props} from './types'

export function PaymentTitle(props: Props) {
  const {method} = props
  const title = usePaymentTitle(method)

  return (
    <Typography group="tight" variant="body2" whiteSpace="nowrap">
      {title}
    </Typography>
  )
}
